/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

import {DropdownButtonVariant} from './index';

const getStyles = (variant: DropdownButtonVariant, disabled: boolean) => {
  if (disabled) {
    return {
      backgroundColor: '#a5a6ab',
      color: '#838489',
      cursor: 'default',
      '&:hover': {
        backgroundColor: '#a5a6ab',
      },
      '&:active': {
        backgroundColor: '#a5a6ab',
      },
    };
  }

  switch (variant) {
    case 'primary':
      return {
        minWidth: '182px',
        color: '#f9fcfa',
        backgroundColor: '#419466',
        '&:hover': {
          backgroundColor: '#5ab983',
        },
        '&:active': {
          backgroundColor: '#86caa0',
        },
      };
    case 'secondary':
      return {
        color: '#141414',
        background: '#e2e3e9',
        '&:hover': {
          backgroundColor: '#cdced4',
        },
      };
    case 'red':
      return {
        color: '#C06868',
        background: 'none',
        border: 'none',
        fontWeight: 400,
      };
    default:
      return {};
  }
};

interface DropdownButtonProps {
  variant: DropdownButtonVariant;
  disabled: boolean;
}

const Root = styled(Box, {
  shouldForwardProp: prop => prop !== 'variant' && prop !== 'disabled',
})<DropdownButtonProps>(({theme, variant, disabled}) => ({
  width: '100%',

  '.MuiButtonBase-root': {
    border: 'none',
    borderRadius: theme.spacing(2),
    fontSize: '14px',
    lineHeight: '16px',
    height: '32px',
    width: '100%',
    transition: 'background-color 0.2s',
    ...getStyles(variant, disabled),
  },
}));

export {Root as DropdownButtonRoot};
